import * as Yup from "yup";
// "mobile" metadata does strict digit-pattern validation; the default "min" bundle only checks
// plausible length, so e.g. a truncated or malformed number could still pass as "valid".
import { isValidPhoneNumber } from "react-phone-number-input/mobile";
import { IPayOutType } from "../../../store/services/affiliate/dto/affiliate.dto";

export const affiliateCodeSchema = Yup.object({
	code: Yup.string()
		.trim()
		.required("Please enter a code")
		.max(6, "Code must be at most 6 characters")
		.matches(/^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]+$/, "Code must be a mix of letters and numbers, e.g. JANE15")
});

export const createAffiliateSchema = Yup.object({
	businessName: Yup.string().trim().required("Please enter your business name"),
	type: Yup.string().oneOf(Object.values(IPayOutType)).required(),
	holderName: Yup.string().trim().required("Please enter the account holder name"),
	bankName: Yup.string().when("type", {
		is: IPayOutType.BANK,
		then: schema => schema.trim().required("Please enter your bank name")
	}),
	accountNumber: Yup.string().when("type", {
		is: IPayOutType.BANK,
		then: schema =>
			schema
				.trim()
				.required("Please enter your account number")
				.matches(/^[0-9]{8,20}$/, "Account number must be 8-20 digits")
	}),
	walletMobileNumber: Yup.string().when("type", {
		is: IPayOutType.WALLET,
		then: schema =>
			schema
				.required("Please enter your wallet mobile number")
				.test("is-valid-phone", "Enter a valid mobile number", value => !!value && isValidPhoneNumber(value))
	}),
	agreedToRules: Yup.boolean().oneOf([true], "You must agree to the Affiliate Program Rules")
});
